import { DesignSystem } from "@microsoft/fast-foundation";
import {
  provideGSPDesignSystem,
  gspTabs,
  gspTab,
  gspTabPanel,
  gspCard,
  gspCardHeader,
  gspCardBody,
  gspCardActions,
  gspTrendLabelComponent,
  gspChartDoughnut,
  gspSecondaryButton,
  gspPrimaryAnchor,
  gspDivider,
  gspPrimaryButton,
  gspTertiaryButton,
  gspFabButton,
  gspCalendar,
  gspCalendarErrorMessage,
  gspCheckbox,
  gspDatepicker,
  gspDatepickerErrorMessage,
  gspDatepickerIcon,
  gspDialog,
  gspDialogHeader,
  gspDialogBody,
  gspDialogFooter,
  gspMenu,
  gspMenuItem,
  gspAnchoredRegion,
  gspNavList,
  gspNavDisclosure,
  gspNavListItem,
  gspRadio,
  gspRadioGroup,
  gspTextField,
  gspSelect,
  gspOption,
  gspSelectErrorMessage,
  gspSidenavContainer,
  gspSidenav,
  gspSidenavContent,
  gspTextFieldErrorMessage,
  gspTextFieldErrorIcon,
  gspTooltip,
  gspSecondaryBadge,
  gspPrimaryBadge,
  gspAlertSuccess,
  gspAlertError,
  gspAlertAccent,
  gspLoader,
  gspIcon,
} from "@gsp-design-system/elements";

export default function regGspDesignSystem() {
  // IMP: do not re-register components when loaded in the MF Shell/Host application i.e. KeaWebUI
  if (!DesignSystem.getOrCreate(document.body).designTokensInitialized) {
    provideGSPDesignSystem(document.body).register(
      gspTabs(),
      gspTab(),
      gspTabPanel(),
      gspCard(),
      gspCardHeader(),
      gspCardBody(),
      gspCardActions(),
      gspTrendLabelComponent(),
      gspChartDoughnut(),
      gspSecondaryButton(),
      gspPrimaryAnchor(),
      gspDivider(),
      gspPrimaryButton(),
      gspSecondaryButton(),
      gspTertiaryButton(),
      gspFabButton(),
      gspCalendar(),
      gspCalendarErrorMessage(),
      gspCheckbox(),
      gspDatepicker(),
      gspDatepickerErrorMessage(),
      gspDatepickerIcon(),
      gspDialog(),
      gspDialogHeader(),
      gspDialogBody(),
      gspDialogFooter(),
      gspMenu(),
      gspMenuItem(),
      gspAnchoredRegion(),
      gspNavList(),
      gspNavDisclosure(),
      gspNavList(),
      gspNavListItem(),
      gspNavDisclosure(),
      gspRadio(),
      gspRadioGroup(),
      gspTextField(),
      gspSelect(),
      gspOption(),
      gspSelectErrorMessage(),
      gspSidenavContainer(),
      gspSidenav(),
      gspSidenavContent(),
      gspTab(),
      gspTabs(),
      gspTabPanel(),
      gspTextField(),
      gspTextFieldErrorMessage(),
      gspTextFieldErrorIcon(),
      gspTooltip(),
      gspAnchoredRegion(),
      gspPrimaryBadge(),
      gspSecondaryBadge(),
      gspAlertSuccess(),
      gspAlertError(),
      gspAlertAccent(),
      gspLoader(),
      gspIcon()
    );
  }
}
